import {
    GET_BANKS,
    GET_BANKS_SUCCESS,
    GET_BANKS_FAIL,
    SAVE_BANKS,
    SAVE_BANKS_SUCCES,
    SAVE_BANKS_ERROR,
    DELETE_BANK,
    DELETE_BANK_SUCCESS,
    DELETE_BANK_FAIL,
    EDIT_BANK,
    EDIT_BANK_SUCCESS,
    EDIT_BANK_FAIL,
    INIT_BANK

} from "./actionTypes"
export const initData = data => {
    return {
        type: INIT_BANK,
        payload: data,
    }
}

export const saveBankNew = bank => {
    return {
        type: SAVE_BANKS,
        payload: bank,
    }
}

export const getBanks = banks => {
    return {
        type: GET_BANKS,
        payload: { banks }
    }
}
export const getBanksSuccess = bank => ({
    type: GET_BANKS_SUCCESS,
    payload: bank,
})

export const getBanksFail = error => ({
    type: GET_BANKS_FAIL,
    payload: error,
})
export const deleteBanks = (data) => {
    return {
        type: DELETE_BANK,
        payload: data
    }
}
export const deleteBanksSuccess = bank => ({
    type: DELETE_BANK_SUCCESS,
    payload: bank,
})

export const deleteBanksFail = error => ({
    type: DELETE_BANK_FAIL,
    payload: error,
})
export const editBankSuccess = bank => ({
    type: EDIT_BANK_SUCCESS,
    payload: bank,
})

export const editBankFail = error => ({
    type: EDIT_BANK_FAIL,
    payload: error,
})
export const editBank = bank => ({
    type: EDIT_BANK,
    payload: bank,
})
export const saveBankSuccess = bank => {
    return {
        type: SAVE_BANKS_SUCCES,
        payload: bank,
    }
}

export const saveBankError = error => {
    return {
        type: SAVE_BANKS_ERROR,
        payload: error,
    }
}
